const list = [
  {
    id: 1,
    title: '商务拓展经理（WIFI方向）',
    type: '市场',
    experience: '四年工作经验',
    address: '深圳',
    date: '2024-03-01',
    requirement: ['根据公司市场战略和定位，参与制定公司的市场总体工作规划；', '主导品牌策划、品牌建设和推广，通过线上营销和线下会议营销、专题沙龙、渠道峰会等活动的策划与执行为业务团队挖掘商机和线索；', '建立和完善公司新媒体矩阵，负责进行日常运营和推广；根据公司产品特征对目标市场进行有针对性的调研、预测，收集国家政策法规及相关规定、产品市场信息和行业数据，为营销决策提供建议；']
  },
  {
    id: 2,
    title: '商务拓展总监/VP',
    type: '市场',
    experience: '四年工作经验',
    address: '深圳',
    date: '2024-03-01',
    requirement: ['根据公司市场战略和定位，参与制定公司的市场总体工作规划；', '主导品牌策划、品牌建设和推广，通过线上营销和线下会议营销、专题沙龙、渠道峰会等活动的策划与执行为业务团队挖掘商机和线索；', '建立和完善公司新媒体矩阵，负责进行日常运营和推广；根据公司产品特征对目标市场进行有针对性的调研、预测，收集国家政策法规及相关规定、产品市场信息和行业数据，为营销决策提供建议；']
  },

  {
    id: 3,
    title: '高级产品经理',
    type: '市场',
    experience: '四年工作经验',
    address: '深圳',
    date: '2024-03-01',
    requirement: ['根据公司市场战略和定位，参与制定公司的市场总体工作规划；', '主导品牌策划、品牌建设和推广，通过线上营销和线下会议营销、专题沙龙、渠道峰会等活动的策划与执行为业务团队挖掘商机和线索；', '建立和完善公司新媒体矩阵，负责进行日常运营和推广；根据公司产品特征对目标市场进行有针对性的调研、预测，收集国家政策法规及相关规定、产品市场信息和行业数据，为营销决策提供建议；']
  },

  {
    id: 4,
    title: '基础平台产品经理',
    type: '市场',
    experience: '四年工作经验',
    address: '深圳',
    date: '2024-03-01',
    requirement: ['根据公司市场战略和定位，参与制定公司的市场总体工作规划；', '主导品牌策划、品牌建设和推广，通过线上营销和线下会议营销、专题沙龙、渠道峰会等活动的策划与执行为业务团队挖掘商机和线索；', '建立和完善公司新媒体矩阵，负责进行日常运营和推广；根据公司产品特征对目标市场进行有针对性的调研、预测，收集国家政策法规及相关规定、产品市场信息和行业数据，为营销决策提供建议；']
  },

  {
    id: 5,
    title: 'Java开发工程师',
    type: '市场',
    experience: '四年工作经验',
    address: '深圳',
    date: '2024-03-01',
    requirement: ['根据公司市场战略和定位，参与制定公司的市场总体工作规划；', '主导品牌策划、品牌建设和推广，通过线上营销和线下会议营销、专题沙龙、渠道峰会等活动的策划与执行为业务团队挖掘商机和线索；', '建立和完善公司新媒体矩阵，负责进行日常运营和推广；根据公司产品特征对目标市场进行有针对性的调研、预测，收集国家政策法规及相关规定、产品市场信息和行业数据，为营销决策提供建议；']
  },

]

export default list



// WEBPACK FOOTER //
// ./src/pages/about/recruitment.js